import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "image-window" }
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "carousel-caption" }
const _hoisted_9 = { class: "add-most-padding" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "section-tag" }
const _hoisted_12 = ["href", "innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "premium-badge-on-lead"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "premium-badge small" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Premium Content")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "read-more-btn" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "decoration" }, null, -1)

import { toRefs, onMounted } from "vue";

// Define Component Input Properties

export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    className: String,
    desktopUrl: String,
    mobileUrl: String,
    imageAttribution: String,
    sectionUrl: String,
    sectionTitle: String,
    title: String,
    blurb: String,
    contentUrl: String,
    premium: Boolean,
},
  setup(__props) {

const props = __props;



// get back slide card info
const {
    className,
    desktopUrl,
    mobileUrl,
    imageAttribution,
    sectionUrl,
    sectionTitle,
    title,
    blurb,
    contentUrl,
    premium,
} = toRefs(props);

// when script loads initially set the first one to active
onMounted(() => {
    const topElement = document.getElementById("carousel-inner");
    topElement.children[0].classList.add("active");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(className))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("picture", null, [
          _createElementVNode("source", {
            media: "(min-width: 768px)",
            srcset: _unref(desktopUrl)
          }, null, 8, _hoisted_3),
          _createElementVNode("source", { srcset: _unref(mobileUrl) }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            class: "d-block w-100",
            srcset: _unref(desktopUrl)
          }, null, 8, _hoisted_5),
          _createElementVNode("div", {
            class: "img-attribution",
            innerHTML: decodeURIComponent(_unref(imageAttribution))
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("aside", _hoisted_11, [
                _createElementVNode("a", {
                  href: _unref(sectionUrl),
                  class: "tag",
                  innerHTML: decodeURIComponent(_unref(sectionTitle))
                }, null, 8, _hoisted_12)
              ]),
              (_unref(premium))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h2", {
              innerHTML: decodeURIComponent(_unref(title))
            }, null, 8, _hoisted_16),
            _createElementVNode("p", {
              innerHTML: decodeURIComponent(_unref(blurb))
            }, null, 8, _hoisted_17),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", { href: _unref(contentUrl) }, "READ MORE ", 8, _hoisted_19),
              _hoisted_20
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})